<template>
  <div class="file-upload">
    <v-progress-circular
      :width="3"
      color="black"
      indeterminate
      v-if="fetchingData"
    ></v-progress-circular>
    <template v-if="!fetchingData">
      <template v-if="value && value.length > 0">
        <b>Attached files</b>
        <v-row
          v-for="(f, index) in value"
          :key="f.filename"
        >
          <v-col>
            <display-field :label="fileInputLabel(index)">
              <a
                :href="downloadUrl(f)"
                target="_blank"
              >
                {{ f.filename }}
              </a><br />
              <span>{{ f.created_at }}</span>
            </display-field>
          </v-col>
          <v-col>
            <v-btn
              v-if="!readonly"
              color="danger"
              x-small
              @click="removeFile(f)"
            >Remove</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-if="value && value.length == 0 && readonly == true">
        <small>There is no attached files.</small>
      </template>
      <template v-if="canUploadFiles && readonly == false">
        <v-file-input
          v-for="(f, index) in files"
          :label="fileInputLabel(index)"
          :key="f"
          show-size
          truncate-length="18"
          dense
          filled
          :value="files[index]"
          @change="update(index, $event)"
          :loading="loading"
        ></v-file-input>
        <v-btn
          :loading="loading"
          color="primary"
          @click="uploadFiles"
          small
        >Upload</v-btn>
      </template>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import FileSystemService from '@/services/filesystem'
  import DisplayField from '@/components/DisplayField'

  export default {
    name: 'FileUpload',
    components: { DisplayField },
    props: {
      value: {
        default: [],
      },
      multi: {
        default: false,
      },
      module: {
        default: 'general',
      },
      section: {
        default: 'general',
      },
      site_id: {
        default: null,
      },
      item_id: {
        default: null,
      },
      label: {
        default: undefined,
      },
      readonly: {
        default: false,
      },
    },
    data: () => ({
      files: [],
      fetchingData: false,
      loading: false,
      tempItemId: undefined,
    }),
    mounted () {
      this.fetchData()
    },
    computed: {
      canUploadFiles () {
        return this.files.length > 0
      },
    },
    watch: {
      value: function () {
        const limitedValue = []
        for (const val of this.value) {
          limitedValue.push(val.id)
        }
        this.$emit('input', limitedValue)
      },
    },
    methods: {
      getItemId () {
        if (this.item_id) {
          return this.item_id
        }
        if (!this.tempItemId) {
          this.tempItemId = 'TEMP' + new Date().getTime()
        }
        return this.tempItemId
      },
      fetchData () {
        this.fetchingData = true
        this.files = []
        const fs = new FileSystemService(
          this.module,
          this.section,
          this.site_id,
          this.getItemId(),
        )
        fs.getAssignedFiles().then((response) => {
          this.value = response.data.data
          // check for existing files
          if (this.multi) {
            this.files.push(undefined)
          } else if (this.value !== undefined && this.value.length === 0) {
            this.files.push(undefined)
          }
        }).finally(() => {
          this.fetchingData = false
        })
      },
      fileInputLabel (index) {
        if (this.multi) {
          return this.label + ' ' + (index + 1)
        } else {
          return this.label
        }
      },
      update (index, value) {
        this.files[index] = value
        Vue.set(this.files, index, value)
      },
      uploadFiles () {
        this.loading = true
        const fs = new FileSystemService(
          this.module,
          this.section,
          this.site_id,
          this.getItemId(),
        )
        for (const file of this.files) {
          fs.uploadFile(file).then(() => {
            this.fetchData()
          }).finally(() => {
            this.loading = false
          })
        }
      },
      removeFile (f) {
        const fs = new FileSystemService(
          this.module,
          this.section,
          this.site_id,
          this.getItemId(),
        )
        fs.removeFile(f.id).then(() => {
          this.fetchData()
        })
      },
      downloadUrl (f) {
        return '/api/filesystem/download/' + f.id
      },
    },
  }
</script>

<style scoped>
  .file-upload {
    background-color: #f0f0f0;
    padding: 15px;
  }
</style>
